import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import TechHero from './components/TechHero';
import EliteStackGrid from './components/EliteStackGrid';

const TechnologyShowcase = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Byte Pairs Technology Stack & Code Capabilities</title>
        <meta
          name="description"
          content="Explore the technology stack behind Byte Pairs. We use React, Next.js, React Native, Node.js, and Python to build high-performance, custom database software."
        />
        <meta name="keywords" content="software technology stack, React agency, Node.js development, React Native, Python backend, custom databases, Byte Pairs technology, software developers Dharapuram" />
        <meta property="og:title" content="Byte Pairs Technology Stack & Code Capabilities" />
        <meta property="og:description" content="Discover how we leverage modern technologies (React, Node.js, React Native, Python) to build custom billing, ERP, and booking systems." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bytepairs.com/technology-showcase-interactive-capabilities" />
        <link rel="canonical" href="https://bytepairs.com/technology-showcase-interactive-capabilities" />

        {/* WebPage Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Byte Pairs Technology Stack & Code Capabilities",
            "description": "Explore the technologies we use to build robust software: React, Next.js, React Native, Node.js, and Python.",
            "url": "https://bytepairs.com/technology-showcase-interactive-capabilities"
          })}
        </script>

        {/* BreadcrumbList Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://bytepairs.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Technology Stack",
                "item": "https://bytepairs.com/technology-showcase-interactive-capabilities"
              }
            ]
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-slate-950">
        <Header />

        <main className="pt-16">
          {/* Hero Section */}
          <TechHero />

          {/* Elite Stack & Capability Grid */}
          <EliteStackGrid />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TechnologyShowcase;
